import React from 'react'
import PropTypes from 'prop-types'
import { CalendarIcon } from 'src/components/icons'
import LabeledInput from '../LabeledInput'
import { DatePicker } from '../../pickers'
import { datePlaceholder } from '../../../services'

/**
 * A [DatePicker](#DatePicker) rendering its result into a [LabeledInput](#LabeledInput).
 */
const LabeledDateInput = ({ icon, color, ...props }) => (
  <DatePicker color={color} {...props}>
    {({ value, ...props }) => (
      <LabeledInput {...props} value={value} icon={icon} type="text" color={color} placeholder={datePlaceholder} />
    )}
  </DatePicker>
)

LabeledDateInput.defaultProps = {
  icon: CalendarIcon,
  color: 'light',
}

LabeledDateInput.propTypes = {
  /**
   * The icon to display.
   */
  icon: PropTypes.elementType.isRequired,
  /**
   * The input and popup color.
   */
  color: PropTypes.string,
}

export default LabeledDateInput
